import React, { useState } from "react";
import { createSuscrito } from '../../actions/home'

export const SliderSuscribete = () => {
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")

    const handleRegister = async () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            setError("Por favor, introduce un correo electrónico válido.");
            return;
        }
        setError("");

        try {
            const response = await createSuscrito(email, "suscripcion");
            console.log("Suscrito creado:", response);
            setEmail("");
        } catch (error) {
            console.error("Error al crear suscrito:", error);
            setError("Error al crear el suscrito. Inténtalo nuevamente.");
        }
    }


    return (
        <div className="container-suscribete position-relative">
            <img src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=suscrito_xs.jpg&version_id=null" alt="banner-suscribete"
                className="img-responsive suscribete-xs" />

            <img src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=suscrito_sm.jpg&version_id=null" alt="banner-suscribete"
                className="img-responsive suscribete-sm" />

            <div className='input-susribete position-absolute'>
                <input type='text'
                    // placeholder='Ingresa tu correo electrónico'
                    className='font-family-montserrat'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                {error && <div className="error-message">{error}</div>}

            </div>

            <div
                className='button-suscribete font-family-montserrat position-absolute pointer'
                onClick={handleRegister}
            >
                <div className=''>
                    Regístrate
                </div>
            </div>

        </div>

    );
};